<template>
  <div class="contactUs">
    <Header bgColor="rgba(34, 64, 116, 0.9)"></Header>
    <ImgBox :info="infoBoxInfo"></ImgBox>
    <div class="tabBox">
      <div class="tabBox-menu">
        <div
          :class="1 == menuIndex ? 'bianse' : ''"
          @click="goAnchor(1, '/contactUs/contactUsIndex')"
        >
          联系我们
        </div>
        <div
          :class="2 == menuIndex ? 'bianse' : ''"
          @click="goAnchor(2, '/contactUs/contactUsTwo')"
        >
          人才招聘
        </div>
      </div>
    </div>
    <router-view />
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import ImgBox from "@/components/ImgBox.vue";
export default {
  name: "ContactUs",
  components: {
    Header,
    ImgBox,
  },
  data() {
    return {
      // 顶部图片
      infoBoxInfo: {
        img: require("../assets/contact.png"),
        name: "联系我们",
        eng: "CONTACT US",
      },
      //   分类标识
      menuIndex: 1,
    };
  },
  methods: {
    // 点击分类
    goAnchor(index, path) {
      this.menuIndex = index;
      this.$router.push(path);
    },
  },
};
</script>

<style scoped lang="less">
.contactUs {
  width: 100%;
  height: auto;
}

.tabBox {
  width: 100%;
  height: 60px;
  background-color: #224074;

  .tabBox-menu {
    width: 1400px;
    height: 100%;
    margin: auto;
    display: flex;
    justify-content: flex-end;

    > div {
      width: 140px;
      height: 100%;
      background-color: transparent;
      font-size: 14px;
      color: #ffffff;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;

      &:hover {
        background-color: #e7ce8d;
        color: #224074;
      }
    }

    > .bianse {
      background-color: #e7ce8d;
      color: #224074;
    }
  }
}
</style>
